export default __webpack_public_path__ + "static/thumb_lg_02-ace6dbdf654daebd9fe8ee9dffbf5e42.png";